import { render, staticRenderFns } from "./ActionProfileUpdated.vue?vue&type=template&id=2bf3a0bb&"
import script from "./ActionProfileUpdated.vue?vue&type=script&lang=js&"
export * from "./ActionProfileUpdated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports